
export default function Defs() {

  const shadow_opacity = 0.8;
  const shadow_intensity = 3;

  return (
    <defs>
      <radialGradient id="sunGradient">
        <stop offset="10%" stopColor="#dadada" />
        <stop offset="95%" stopColor="#c0c0c0" />
      </radialGradient>
      <filter id='shadow'>
        <feColorMatrix type='matrix'
          values={` 0.000  0.000  0.000  0.000  0.000
                   0.000  0.000  0.000  0.000  0.000
                   0.000  0.000  0.000  0.000  0.000
                   0.000  0.000  0.000  ${shadow_opacity}  0.000`}
        />
        <feGaussianBlur stdDeviation={shadow_intensity} result='coloredBlur'/>
        <feMerge>
          <feMergeNode in='coloredBlur' />
          <feMergeNode in='SourceGraphic' />
        </feMerge>
      </filter>
    </defs>
  );
}
